<template>
  <v-col class="px-0 py-0">
    <x-org-heading heading="Domain">
      <template slot="org-page-button">
        <x-button
          color="#58e2c2"
          buttonText="Add a Domain"
          @click="toggleOpenOverlay"
        />
      </template>
    </x-org-heading>
    <v-row>
      <x-table
        :columns="columns"
        :loading="loading"
        :updateTableSize="updateTableRowCount"
        :tableRows="domainData"
        :paginationData="{
          pageSize,
          pageNumber,
          totalRecords,
          setPage,
        }"
      >
        <template slot="table-top-right">
          <div class="w-70">
            <search-bar
              @searchItem="searchItem($event)"
              @clearSearch="clearSearch"
            />
          </div>
        </template>
        <template slot="table_item" slot-scope="props">
          <tr
            v-for="item in preferenceServiceHelper.filterPreference(
              props.tableRows
            )"
            :key="item.id"
            class="pointerCursor"
          >
            <TableRowData
              :item="item"
              :setSelectedDomain="setSelectedDomain"
              @removeDomain="removeDomain($event)"
            />
          </tr>
        </template>
      </x-table>
    </v-row>
    <AddDomain
      v-if="openAddDomain"
      :dialogOpen="openAddDomain"
      @closeAddOverlay="toggleOpenOverlay"
      @addSuccess="() => getDomains(true)"
    />
    <RemoveDomain
      v-if="openRemoveDomain"
      :dialogOpen="openRemoveDomain"
      @closeRemoveOverlay="removeDomain"
      :dataToBeDeleted="dataToBeDeleted"
      @removeSuccess="removeCallBack"
    />
  </v-col>
</template>

<script>
const AddDomain = () =>
  import('@/components/Organisations/dialogues/AddDomain');
const RemoveDomain = () =>
  import('@/components/Organisations/dialogues/RemoveDomain');
import TableRowData from './TableRowData';
import SearchBar from './SearchBar';
import PreferencesService from '@/services/PreferencesService';
import PreferenceHelper from '@/helpers/PreferenceHelper';
import { mapMutations } from 'vuex';
// import SearchBar from './SearchBar.vue';
export default {
  components: {
    RemoveDomain,
    AddDomain,
    SearchBar,
    TableRowData
    // SearchBar,
  },
  data() {
    return {
      pageTitle: 'Company name Audit Trail',
      dataToBeDeleted: null,
      columns: [
        {
          label: 'Address',
          field: 'value',
        },
      ],
      domainData: [],
      pageNumber: 1,
      pageSize: 20,
      totalRecords: 0,
      searchDomainVal: '',
      loading: false,
      openAddDomain: false,
      openRemoveDomain: false,
      preferenceServiceHelper: null,
    };
  },
  methods: {
    ...mapMutations('domains', ['setSelectedDomain']),
    toggleOpenOverlay() {
      this.openAddDomain = !this.openAddDomain;
    },
    async getDomains(initial) {
      let paging = {
        pageable: true,
        pageNumber: this.pageNumber,
        size: this.pageSize,
      };
      this.domainData = [];
      this.loading = true;
      if (initial) {
        this.pageNumber = 1;
        this.totalRecords = 0;
        this.pageSize = 20;
      }
      try {
        let response = await PreferencesService.getPreferencesByPreferenceKey(
          this.$preference.DOMAINS,
          paging
        );
        this.updateListData(response);
        this.loading = false;
      } catch (err) {
        this.loading = false;
        this.snackbar('error', err);
      }
    },
    async updateListData(listResponse) {
      let response = this.parseResponse(listResponse);
      if (response !== false) {
        this.totalRecords = response[0].totalResults;
        this.domainData = response[0].results;
        let min_len = 1;
        if (
          this.domainData.length === min_len &&
          this.domainData[0].data &&
          this.domainData[0].data.domain === ''
        ) {
          this.domainData.splice(0, 1);
        }
      } else {
        this.snackbar('error', this.$message.CANNOT_LOAD_SETTING_DATA);
      }
      this.loading = false;
    },
    updateTableRowCount(val) {
      this.pageSize = val;
      this.setPage(1);
    },
    setPage(page) {
      this.pageNumber = page;
      if (!this.searchDomainVal || this.searchDomainVal === '') {
        this.getDomains();
      } else {
        this.searchItem({ pageNumber: this.pageNumber });
      }
    },
    clearSearch() {
      this.pageNumber = 1;
      this.totalRecords = 0;
      this.getDomains();
    },
    async searchItem({ pageNumber, searchDomainVal }) {
      //search email list function
      this.searchDomainVal = searchDomainVal;
      let paging = {
        pageable: true,
        pageNumber: pageNumber,
        size: this.pageSize,
      };
      this.pageNumber = pageNumber;
      this.domainData = [];
      if (pageNumber === 1) {
        this.totalRecords = 0;
      }
      this.loading = true;
      try {
        let response = await PreferencesService.searchPreferences(
          this.$preference.DOMAINS,
          this.searchDomainVal,
          paging
        );
        this.updateListData(response);
      } catch (err) {
        this.loading = false;
        this.snackbar('error', err);
      }
    },
    removeDomain(data) {
      if (data && data !== null) {
        this.dataToBeDeleted = data;
      }
      this.openRemoveDomain = !this.openRemoveDomain;
    },
    removeCallBack() {
      if (
        this.domainData.length === 1 &&
        Math.ceil(this.totalRecords / this.pageSize) === this.pageNumber &&
        this.pageNumber !== 1
      ) {
        this.pageNumber--;
      }
      this.setPage(this.pageNumber);
    },
  },
  created() {
    this.preferenceServiceHelper = new PreferenceHelper();
  },
  mounted() {
    this.getDomains(true);
  },
  watch: {
    currentlySelectedOrgId: function () {
      this.getDomains(true);
    },
  },
};
</script>
